<div class="di-majoration">	
	<lua-icone 
		[class.majoration-disabled]="disabled"
		color="CouleurPrimaire" 
		[mode]="getIconMode()" 
		[width]="getIconSize()" 
		[height]="getIconSize()"
		[iconName]="getMajorationDetails().iconName" 
		[customIconName]="getMajorationDetails().customIconeName"
		[isIcon]="!!getMajorationDetails().customIconeName">
	</lua-icone>
	<ng-container *ngIf="!icon">
		<div class="description-container">
			<p class="label" [class.with-information]="information">{{ getMajorationDetails().label }}</p>
			<div class="description-end-container" [class.with-information]="information">
				<lua-bouton-icone *ngIf="information" iconName="info" (onClick)="showInfoMajoration($event)" mode="outlined"></lua-bouton-icone>
				<p *ngIf="price" class="price">{{ priceLabel | number:'1.2-2' }} €</p>
			</div>
		</div>
	</ng-container>
</div>